"use client";
import AnimatedText from "@/components/common/AnimatedText";
import { parallaxMouseMovement } from "@/utils/parallax";

import { useEffect, useState } from "react";
import Link from "next/link";

import { useTranslation } from 'react-i18next';
import { useParams } from 'next/navigation';

export default function Hero() {
  const { t } = useTranslation();
  const params = useParams();
  const locale = params?.locale;

  useEffect(() => {
    parallaxMouseMovement();
  }, []);
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="container min-height-100vh d-flex align-items-center pt-100 pb-100 pt-sm-120 pb-sm-120">
        {/* Home Section Content */}
        <div className="home-content text-start">
          <div className="row">
            {/* Home Section Text */}
            <div className="col-md-6 d-flex align-items-center mb-sm-60 main-hero">
              <div>

                <h1 className="hs-title-1 mb-30">
                  <AnimatedText
                    text={t('main_hero_title')}
                  />
                </h1>

                <p
                  className="section-descr mb-50 wow fadeInUp"
                  data-wow-delay="0.6s"
                  data-wow-duration="1.2s"
                >
                  {t('main_hero_sub')}
                </p>
                <div
                  className="wow fadeInUp"
                  data-wow-delay="0.8s"
                  data-wow-duration="1.2s"
                >
                  <Link
                    href={locale ? `/${locale}/libros` : '/libros'}
                    className="btn btn-mod btn-circle btn-large"
                  >
                    {t('main_hero_books_btn')}
                  </Link>
                </div>
              </div>
            </div>
            {/* End Home Section Text */}
          </div>
        </div>
        {/* End Home Section Content */}
      </div>
    </>
  );
}
